import * as types from '../constants/ActionTypes'

let defaultState = {
    isOpen:false,
    componentVisible: "select",
    isNewSession: false,
    isInternalUpload: false,
    sessionName: "",
    uploadPath: "",
    uploadedImages: [],
    uploadedDocuments: [],
    currentVideoUploading: {},
    session: {},
    scope: "",
    sessionType: ""
}

export default function app(state = defaultState, action){
    switch(action.type){
        case types.RESET_MEDIA_UPLOAD_STATE:
            return state = defaultState;
        case types.SHOW_HIDE_MEDIA_UPLOAD:
            // console.log("REDUCERS", action, state)
            return {...state, isOpen: action.payload}
        case types.SET_VISIBLE_UPLOAD_COMPONENT:
            // console.log("REDUCERS", action, state)
            return {...state, componentVisible: action.payload}
        case types.SET_CURRENT_SESSION:
            // console.log("REDUCERS", action, state)
            return {...state, session: action.payload}
        case types.SET_CURRENT_PATIENT_IN_SESSION:
            // console.log("REDUCERS", action, state)
            return {...state, session:{ 
                ...state.session,
               patient: action.payload
            }}
        case types.SET_IS_SESSION:
            // console.log("REDUCERS", action, state)
            return {...state, isNewSession: action.payload}
        case types.SET_IS_INTERNAL_UPLOAD:
            // console.log("REDUCERS", action, state)
            return {...state, isInternalUpload: action.payload}
        case types.SET_SESSION_NAME:
            // console.log("REDUCERS", action, state)
            return {...state, sessionName: action.payload}
        case types.SET_UPLOAD_PATH:
            // console.log("REDUCERS", action)
            return {...state, uploadPath: action.payload}
        case types.SET_VIDEO_CURRENTLY_UPLOADING:
            // console.log("REDUCERS", action)
            return {...state, currentVideoUploading: action.payload}
        case types.SET_SCOPE_AND_SESSION_TYPE:
            // console.log("REDUCERS", action)
            return {...state, scope: action.payload.scope, sessionType: action.payload.sessionType, parent: action.payload.parent, therapist: action.payload.therapist}
        case types.SET_UPLOADED_IMAGE:
            // console.log("REDUCERS", action)
            return {...state, 
                        uploadedImages: [...state.uploadedImages, action.payload]
                    }
        case types.SET_UPLOADED_DOCUMENT:
            // console.log("REDUCERS", action)
            return {...state, 
                uploadedDocuments: [...state.uploadedDocuments, action.payload]
            }
        default:
            // console.log("RESETTING MEDIA UPLOAD STATE")
            return state
    }
}


// WEBPACK FOOTER //
// ./src/reducers/media_upload.js